import styled from 'styled-components';
import Input from 'components/base/Input';
import { StyledInputLabel } from '../MonitoringRulesForm.style';

const StyledInputRegex = styled.div`
  margin: 2rem 0;
`;

const InputRegex = ({
  inputType,
  title,
  value,
  onChange,
  disabled = false
}) => {
  return (
    <StyledInputRegex>
      {title && <StyledInputLabel>{title}</StyledInputLabel>}
      <Input
        dataCy={`${inputType}-regex`}
        height='3rem'
        width='36rem'
        value={value}
        onChange={onChange}
        placeholder='Type in Regex'
        disabled={disabled}
      />
    </StyledInputRegex>
  );
};

export default InputRegex;
